<template>
  <Breadcrumbs
      title="Direct Lost Sale Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Direct Lost Sale Report', path: '/direct-loss-sale-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <directLossSale />
    </div>
  </div>
</template>

<script>
import directLossSale from './directLossSaleForm.vue'
export default {
  name: 'indexList',
  components: {
    directLossSale,
  },
}
</script>
